module.exports = __webpack_public_path__ + "images/icon@2x.png?ad6a308f4d4bf21f0c34d8417f9e7e07";


//////////////////
// WEBPACK FOOTER
// ./src/statics/img/icon@2x.png
// module id = 3
// module chunks = 1